<template>
  <b-form-group
    label="Çıkış Hesap"
    label-for="id_donation_types"
  >
    <validation-provider
      #default="{ errors }"
      name="Çıkış Hesap"
      rules="required"
    >
      <b-form-radio-group
        id="id_donation_types"
        v-model="dataItem.id_donation_types"
        :options="donationTypes"
        text-field="title"
        value-field="id"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormRadioGroup,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'DonationTypes',
  components: {
    BFormGroup,
    BFormRadioGroup,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['donationGroups/dataItem']
    },
    donationTypes() {
      return this.$store.getters['donationTypes/dataList']
    },
  },
  created() {
    localize('tr')
    this.getDonationTypes()
  },
  methods: {
    getDonationTypes() {
      this.$store.dispatch('donationTypes/getDataList', {
        select: [
          'donation_types.id AS id',
          'donation_types.title AS title',
        ],
      })
    },
  },
}
</script>
